/* tslint:disable */
/* eslint-disable */
/**
 * Plateformes API
 * API for managing plateformes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MinimalPlateformeDto } from './MinimalPlateformeDto';
import {
    MinimalPlateformeDtoFromJSON,
    MinimalPlateformeDtoFromJSONTyped,
    MinimalPlateformeDtoToJSON,
    MinimalPlateformeDtoToJSONTyped,
} from './MinimalPlateformeDto';

/**
 * 
 * @export
 * @interface ConnexionStandardResponse
 */
export interface ConnexionStandardResponse {
    /**
     * Plateformes standard du compte (les plateformes en SSO partenaire en sont exclues).
     * @type {Array<MinimalPlateformeDto>}
     * @memberof ConnexionStandardResponse
     */
    plateformes: Array<MinimalPlateformeDto>;
    /**
     * Plateforme active après la déclaration de connexion standard.
     * @type {MinimalPlateformeDto}
     * @memberof ConnexionStandardResponse
     */
    currentPlateforme?: MinimalPlateformeDto | null;
    /**
     * Vrai quand le compte a plus d'une plateforme standard (écran de choix).
     * @type {boolean}
     * @memberof ConnexionStandardResponse
     */
    choixRequis: boolean;
    /**
     * Vrai quand le compte a des plateformes mais aucune standard (accès par le partenaire).
     * @type {boolean}
     * @memberof ConnexionStandardResponse
     */
    accesRefuse: boolean;
}

/**
 * Check if a given object implements the ConnexionStandardResponse interface.
 */
export function instanceOfConnexionStandardResponse(value: object): value is ConnexionStandardResponse {
    if (!('plateformes' in value) || value['plateformes'] === undefined) return false;
    if (!('choixRequis' in value) || value['choixRequis'] === undefined) return false;
    if (!('accesRefuse' in value) || value['accesRefuse'] === undefined) return false;
    return true;
}

export function ConnexionStandardResponseFromJSON(json: any): ConnexionStandardResponse {
    return ConnexionStandardResponseFromJSONTyped(json, false);
}

export function ConnexionStandardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnexionStandardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'plateformes': ((json['plateformes'] as Array<any>).map(MinimalPlateformeDtoFromJSON)),
        'currentPlateforme': json['currentPlateforme'] == null ? undefined : MinimalPlateformeDtoFromJSON(json['currentPlateforme']),
        'choixRequis': json['choixRequis'],
        'accesRefuse': json['accesRefuse'],
    };
}

export function ConnexionStandardResponseToJSON(json: any): ConnexionStandardResponse {
    return ConnexionStandardResponseToJSONTyped(json, false);
}

export function ConnexionStandardResponseToJSONTyped(value?: ConnexionStandardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plateformes': ((value['plateformes'] as Array<any>).map(MinimalPlateformeDtoToJSON)),
        'currentPlateforme': MinimalPlateformeDtoToJSON(value['currentPlateforme']),
        'choixRequis': value['choixRequis'],
        'accesRefuse': value['accesRefuse'],
    };
}

